import React, { useMemo } from 'react'
import { GridRow } from 'src/components/Reusable/Grid'
import { StickyGridHeader } from 'src/components/Reusable/Grid/Grid.styles'
import {
  bannerHeight,
  filterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import { useBannerContext } from 'src/context/Banner/BannerContext'

export const AuditIndexGridHeader = (): JSX.Element => {
  const { bannerCount } = useBannerContext()
  const gridTop = useMemo(
    () => headerContentHeight + filterBarHeight + bannerCount * bannerHeight,
    [bannerCount],
  )

  return (
    <GridRow>
      <StickyGridHeader $top={gridTop} />
      <StickyGridHeader $top={gridTop}>Name</StickyGridHeader>
      <StickyGridHeader $top={gridTop}>Frameworks</StickyGridHeader>
      <StickyGridHeader $top={gridTop}>Date Range</StickyGridHeader>
      <StickyGridHeader $top={gridTop}>Status</StickyGridHeader>
      <StickyGridHeader $top={gridTop} />
    </GridRow>
  )
}
